export default function convertExcludedFiltersToIncludedFilters (excludedFilters) {
  return Object.keys(excludedFilters).reduce((acc, key) => {
    const newKey = key.replace(/^excluded/, "").replace(/^./, c => c.toLowerCase());
    acc[newKey] = excludedFilters[key];
    return acc;
  }, {});
}
